import { IconPropsType } from '..';

export const GarbageIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9.61882 2.0999L8.9001 1.3999H6.09642L5.4001 2.0999H2.6001V3.4999H12.4001V2.0999H9.61882Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.0001 11.3553C4.0012 11.6851 4.13269 12.001 4.36586 12.2341C4.59902 12.4673 4.91495 12.5988 5.2447 12.5999H9.7555C10.0852 12.5988 10.4012 12.4673 10.6343 12.2341C10.8675 12.001 10.999 11.6851 11.0001 11.3553L11.7001 4.8999H3.3001L4.0001 11.3553Z"
    />
  </svg>
);
